// API Configuration
const normalizeApiBaseUrl = (url) => {
  if (!url) return undefined;

  const trimmedUrl = url.replace(/\/+$/, '');
  return trimmedUrl.endsWith('/api') ? trimmedUrl : `${trimmedUrl}/api`;
};

const runtimeApiBaseUrl =
  typeof window !== 'undefined'
    ? normalizeApiBaseUrl(
        window._env_?.REACT_APP_API_BASE_URL || window._env_?.REACT_APP_BACKEND_URL
      )
    : undefined;

export const API_BASE_URL =
  runtimeApiBaseUrl ||
  normalizeApiBaseUrl(process.env.REACT_APP_API_BASE_URL) ||
  (process.env.NODE_ENV === 'development' ? 'http://localhost:8000/api' : '/api');

export const getApiUrl = () => {
  return API_BASE_URL;
};
